import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65515a92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "categories" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "categories-heading" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Select a Category")
], -1))
const _hoisted_3 = { class: "categories-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "category-image" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "category-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
        return (_openBlock(), _createElementBlock("button", {
          class: "category",
          key: category.id,
          onClick: ($event: any) => (_ctx.select(category))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: category.imageUrl,
              alt: category.title
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(category.title), 1)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}